import { selectPlusFieldSetup } from "./SelectPlus/js/field"
import { translatableFieldSetup } from "./Translatable/js/field"
import { jsonTagsFieldSetup } from "./JsonTags/js/field"
import { persianNumberFieldSetup } from "./PersianNumber/js/field"
import { persianDateFieldSetup } from "./PersianDate/js/field"
import { ajaxSelectFieldSetup } from "./AjaxSelect/js/field"
import { tabsFieldSetup } from "./Tabs/js/field"
import { hasManySelectFieldSetup } from "./HasManySelect/js/field"
import { arrayImagesFieldSetup } from "./ArrayImages/js/field"
import { internationalCurrencyFieldSetup } from "./InternationalCurrency/js/field"
import { buttonFieldSetup } from "./Button/js/field"
import { ckEditorFieldSetup } from "./CkEditor/js/field"
import { phoneNumberFieldSetup } from "./PhoneNumber/js/field"

const registerCustomeFields = (app) => {
  selectPlusFieldSetup(app)
  translatableFieldSetup(app)
  jsonTagsFieldSetup(app)
  persianNumberFieldSetup(app)
  persianDateFieldSetup(app)
  ajaxSelectFieldSetup(app)
  tabsFieldSetup(app)
  hasManySelectFieldSetup(app)
  arrayImagesFieldSetup(app)
  internationalCurrencyFieldSetup(app)
  buttonFieldSetup(app)
  ckEditorFieldSetup(app)
  phoneNumberFieldSetup(app)
}

export { registerCustomeFields }